<template>

  <div class="container">

    <div v-if="!darkMode" class="monLogo">
      <router-link to="/">
        <img src="@/assets/home_blue.png" alt="logo Accueil" class="logo" />
      </router-link>
    </div>

    <div v-if="darkMode" class="monLogo">
      <router-link to="/">
        <img src="@/assets/home_white.png" alt="logo Accueil" class="logo" />
      </router-link>
    </div>

    <div class="containerP">

      <div class="description">
      <h1 v-if="!darkMode" class="titleP">Projets</h1>
      <h1 v-if="darkMode" class="titlePDark">Projets</h1>
      <p v-if="!darkMode" class="textP">Découvrez mes projets réalisés en développement Front-End et Back-End. 
    J'ai travaillé sur des interfaces utilisateurs intuitives et réactives, 
    ainsi que sur des architectures back-end robustes et sécurisées, en utilisant des technologies modernes.</p>
      <p v-if="darkMode" class="textPDark">Découvrez mes projets réalisés en développement Front-End et Back-End. 
    J'ai travaillé sur des interfaces utilisateurs intuitives et réactives, 
    ainsi que sur des architectures back-end robustes et sécurisées, en utilisant des technologies modernes.</p>
      </div>

      <div v-if="!darkMode" class="buttons">

        <router-link to="/frontend" class="btn">Front-End</router-link>
        <router-link to="/backend" class="btn">Back-End</router-link>

      </div>

      <div v-if="darkMode" class="buttonsDark">

        <router-link to="/frontend" class="btnDark">Front-End</router-link>
        <router-link to="/backend" class="btnDark">Back-End</router-link>

      </div>
      
      <div class="hexagon-gallery">
        <div class="hexagon">
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
        </div>
        <div class="hexagon">
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode"  src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
        </div>
        <div class="hexagon">
          <div>
          <div class="hex">
            <video src="@/assets/calculIMC.mp4" autoplay loop muted></video>
          </div>
        </div>
          <div class="hex">
            <video src="@/assets/textNeon.mp4" autoplay loop muted></video>
          </div>
        </div>
      </div>



      <div class="hexagon-gallery gallery3">
        <div class="hexagon">
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/galleryEffect.png" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
        </div>
        <div class="hexagon">
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <video src="@/assets/siteJapon.mp4" autoplay loop muted></video>
          </div>
          <div class="hex">
            <img src="@/assets/cssGridResponsive.png" alt="">
          </div>
        </div>
        <div class="hexagon">
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
        </div>
      </div>



      <div class="hexagon-gallery gallery4">
        <div class="hexagon">
          <div class="hex">
            <img src="@/assets/shi-fu-mi.png" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
        </div>
        <div class="hexagon">
          <div class="hex">
            <video src="@/assets/slide.mp4" autoplay loop muted></video>
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
        </div>
        <div class="hexagon">
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
        </div>
      </div>



      <div class="hexagon-gallery gallery5">
        <div class="hexagon">
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
        </div>
        <div class="hexagon">
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
        </div>
        <div class="hexagon">
          <div class="hex">
            <video src="@/assets/events.mp4" autoplay loop muted></video>
          </div>
          <div class="hex">
            <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
            <img v-else src="@/assets/blackSand.jpg" alt="">
          </div>
        </div>
      </div>


      <div class="hexaSolo">
        <div class="hexaS">
          <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
          <img v-else src="@/assets/blackSand.jpg" alt="">
        </div>
      </div>


      <div class="hexaSolo solo2">
        <div class="hexaS">
          <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
          <img v-else src="@/assets/blackSand.jpg" alt="">
        </div>
      </div>



      <div class="hexaSolo solo4">
        <div class="hexaS">
          <img src="@/assets/morpion.png" alt="">
        </div>
      </div>


      <div class="hexaSolo solo5">
        <div class="hexaS">
          <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
          <img v-else src="@/assets/blackSand.jpg" alt="">
        </div>
      </div>


      <div class="hexaSolo solo6">
        <div class="hexaS">
          <img src="@/assets/cube3d.png" alt="">
        </div>
      </div>

      <div class="hexaSolo solo7">
        <div class="hexaS">
          <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
          <img v-else src="@/assets/blackSand.jpg" alt="">
        </div>
      </div>

      <div class="hexaSolo solo8">
        <div class="hexaS">
          <img v-if="!darkMode" src="@/assets/bleuF.jpg" alt="">
          <img v-else src="@/assets/blackSand.jpg" alt="">
        </div>
      </div>




    </div>
  </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';

  export default {
    computed: {
      ...mapState(['darkMode']),
    },

  }


  </script>
  


  <style scoped>
*, ::before, ::after{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}


.container{
  width: 100%;
  height: 100vh;
  overflow: hidden;

}

.monLogo{
  position: absolute;
  z-index: 10;
  top: 10px;
  left: 10px;
}

.monLogo img{
  width: 30px;
  height: auto;
}

  .description{
    position: absolute;
    width: 25rem;
    top: 10%;
    left: 1rem;
  }

  .buttons{
    position: absolute;
    display: flex;
    gap: 1rem;
    top: 60%;
    left: 6rem;
  }

  .buttonsDark{
    position: absolute;
    display: flex;
    gap: 1rem;
    top: 60%;
    left: 6rem;
  }

  .buttons .btn{
    border: 2px solid #004080;
    outline: none;
    cursor: pointer;
    padding: 0.5rem 1rem;
    transition: transform 0.3s ease;
    text-decoration: none;
    color: #004080;
    background: #f0f0f0;
    font-family: inherit;
    font-size: inherit;
    border-radius: 5px;
  }

  .buttonsDark .btnDark{
    border: 2px solid #fff;
    outline: none;
    cursor: pointer;
    padding: 0.5rem 1rem;
    transition: transform 0.3s ease;
    text-decoration: none;
    color: #fff;
    background: black;
    font-family: inherit;
    font-size: inherit;
    border-radius: 5px;
  }

  .buttons .btn:hover{
    background-color: #004080;
    color: #fff;
    border-radius: 5px;
    transform: scale(1.1);
    transition: transform 0.3s ease;
  }

  .buttonsDark .btnDark:hover{
    background-color: #fff;
    color: black;
    border-radius: 5px;
    transform: scale(1.1);
    transition: transform 0.3s ease;
  }

  .titleP{
    position: absolute;
    color: transparent;
    font-weight: 900;
    font-size: 80px;
    -webkit-text-stroke: 0.01rem #004080;
    font-family: 'Holtwood One SC', sans-serif;
  
  }

  .titlePDark{
    position: absolute;
    color: transparent;
    font-weight: 900;
    font-size: 80px;
    -webkit-text-stroke: 0.01rem #fff;
    font-family: 'Holtwood One SC', sans-serif;
  }

  .textP{
    position: absolute;
    color: #004080;
    text-align: start;
    top: 12rem;
    left: 1rem;
  }

  .textPDark{
    position: absolute;
    color: #fff;
    text-align: start;
    top: 12rem;
    left: 1rem;
  }

  .containerP{
    display: grid;
    place-items: center;
    text-align: center;
  }

  .description p{
    text-align: justify;
  }

  .hexagon-gallery {
    position: relative;
    width: 492px;
    height: 454px;
    display: grid;
    place-items: center;
    top: -11rem;
    left: 2.8rem;

  
  }

  .gallery2 {
    position: absolute;
    top: 15rem;
    left: 0;
  }

  .gallery3 {
    position: absolute;
    top: 15rem;
    left: 30rem;
  }

  .gallery4 {
    position: absolute;
    top: 15rem;
    left: 60rem;
  }

  .gallery5 {
    position: absolute;
    left: 66rem;
  }

  .hexagon-gallery .hexagon {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    filter: drop-shadow(5px 5px 3px) saturate(2);
    z-index: 1;
  }

  .hexaSolo{
    position: absolute; 
    display: flex;
    justify-content: center;
    align-items: center;
    filter: drop-shadow(5px 5px 3px) saturate(2);
  }

  .hexagon-gallery .hexagon .hex {
    position: relative;
    z-index: -1;
    width: 144px;
    height: 159px;
    display: flex;
    margin: 10px;
    background: rgba(173, 216, 230, 0.2);
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    transition: 0.3s;
    /* cursor: pointer; */

  }


  .hexaSolo{
    top: 6.1rem;
    left: 30rem;
  }

  .hexaSolo .hexaS{
    width: 144px;
    height: 159px;
    display: flex;
    margin: 10px;
    background: rgba(173, 216, 230, 0.2);
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    /* cursor: pointer; */


  }

  .hexagon-gallery .hexagon:nth-child(1) {
    top: 0;
  }

  .hexagon-gallery .hexagon:nth-child(3) {
    bottom: 0;
  }

  .hexagon-gallery .hexagon .hex img {
    filter: brightness(0.5);
    width: 100%;
    transition: 0.3s;

  }

  .hexaSolo .hexaS img{
    filter: brightness(0.5);
    width: 100%;
    transition: 0.3s;
    /* cursor: pointer; */

  }


  .hexagon-gallery .hexagon .hex:hover img {
    filter: brightness(1);
  }

  .solo4 .hexaS:hover img {
    filter: brightness(1);
    /* cursor: pointer; */
  }

  .solo6 .hexaS:hover img {
    filter: brightness(1);
  }

  .hexagon-gallery .hexagon .hex video {
    filter: brightness(0.5);
    width: 100%;
    height: 100%;
    margin: 0 auto;
    object-fit: cover;
    transition: 0.3s;
    /* cursor: pointer; */

  }

  .hexagon-gallery .hexagon .hex:hover video {
    filter: brightness(1);
  }



  .solo2{
    position: absolute;
    top: 32rem;
    left: 25rem;
    /* cursor: pointer; */

  }


  .solo4{
    position: absolute;
    top: 15rem;
    left: 55.2rem;
    /* cursor: pointer; */

  }

  .solo5{
    position: absolute;
    top: 15rem;
    left: 85.8rem;
    /* cursor: pointer; */

  }

  .solo6{
    position: absolute;
    top: 6.2rem;
    left: 60.6rem;
    /* cursor: pointer; */

  }

  .solo7{
    position: absolute;
    top: 6.2rem;
    left: 91.7rem;
    /* cursor: pointer; */

  }

  .solo8{
    position: absolute;
    top: 32.3rem;
    left: 55.2rem;
    /* cursor: pointer; */

  }


  

  


  </style>